import { format, parseISO } from "date-fns";

export const formatDate = (dateStr?: string): string => {
  if (!dateStr) return "";

  try {
    const parsed = parseISO(dateStr);
    const formatted = format(parsed, "yyyy/MM/dd");

    // 無効な初期値チェック
    if (formatted === "0001/01/01") {
      return "";
    }

    return formatted;
  } catch {
    return "";
  }
};
